/* eslint-disable import/no-anonymous-default-export */
import { LISTAR_CAT_VIAS } from "../../types";

export default (state, action) => {
  switch (action.type) {
    case LISTAR_CAT_VIAS:
      return {
        ...state,
        vias: action.payload,
      };

    default:
      return state;
  }
};
